export const getDirtyValues = (form: any, top_level = true) => {
  let dirtyValues = {};

  Object.keys(form.controls)
    .forEach(key => {
      let currentControl = form.controls[key];

      if (currentControl.dirty) {
        if (top_level) {
          dirtyValues[key] = currentControl.value;
        }
        else {
          if (currentControl.controls)
            dirtyValues[key] = getDirtyValues(currentControl);
          else
            dirtyValues[key] = currentControl.value;
        }
      }
    });

  return dirtyValues;
}
